import React from 'react';
import PropTypes from 'prop-types';
import styles from './SortBy.module.less';
import clsx from 'clsx';
import {trackGA} from "../../../services/track";

const DEFAULT_SORT_OPTIONS = {
  popular: 'Most popular',
  featured: 'Featured',
  recent: 'Most recent',
  'title-a-z': 'Alphabetical A-Z',
  'title-z-a': 'Alphabetical Z-A',
  relevance: 'Relevance',
};

const SORT_OPTIONS_WITH_QUERY = {
  relevance: 'Relevance',
  recent: 'Most recent',
  popular: 'Most popular',
  'title-a-z': 'Alphabetical A-Z',
  'title-z-a': 'Alphabetical Z-A',
};

export default function SortBy({
  selectedSort = 'Most popular',
  clickSort,
  contentRequestInProcess,
  hasQuery,
}) {
  const renderSortOptions = () => {
    // Choose the appropriate sort options based on hasQuery
    const sortOptions = hasQuery ? SORT_OPTIONS_WITH_QUERY : DEFAULT_SORT_OPTIONS;

    return Object.entries(sortOptions).map(([key, value], i) => {
      return (
        <option value={key} key={`sort-by-option-${i}`}>
          {value}
        </option>
      );
    });
  };

  const handleChangeSort = e => {
    if (typeof clickSort === 'function') {

      const data = {
        hasQuery: hasQuery,
        value: e.target.value
      };

      // AMH - Likely just temporary to see if anyone actually changes the sort method.
      trackGA('sort', 'ChangeSort', null, data);

      if ((!hasQuery && e.target.value === 'popular') || (hasQuery && e.target.value === 'relevance')) {
        clickSort('');
      } else {
        clickSort(e.target.value);
      }
    }
  };

  return (
    <div className={styles.controls}>
      <div className={styles.sortByWrapper}>
        <div className={styles.sortBy}>
          <span className={styles.text}>Sort by:</span>
          {/* TODO: Make this a label */}
          <select
            className={clsx(
              styles.select,
              contentRequestInProcess && styles.disabled
            )}
            aria-label="sort by"
            value={selectedSort}
            onChange={handleChangeSort}
          >
            {renderSortOptions()}
          </select>
        </div>
      </div>
    </div>
  );
}

SortBy.propTypes = {
  selectedSort: PropTypes.string.isRequired,
  clickSort: PropTypes.func,
  contentRequestInProcess: PropTypes.bool.isRequired,
  hasQuery: PropTypes.bool,
};
